// extracted by mini-css-extract-plugin
export var actionButton = "_f9-t";
export var buttonContainer = "_f9-0";
export var buttonContainer2 = "_f9-1";
export var buttonSection = "_f9-2";
export var details = "_f9-3";
export var dropdownItem = "_f9-5";
export var dropdownItemsContainer = "_f9-4";
export var fileInput = "_f9-r";
export var headerButton = "_f9-6";
export var icon = "_f9-7";
export var input = "_f9-8";
export var macroListItem = "_f9-9";
export var mainContent = "_f9-a";
export var microText = "_f9-b";
export var modal = "_f9-w";
export var optionsButton = "_f9-c";
export var paperclip = "_f9-s";
export var pillContent = "_f9-d";
export var preview = "_f9-e";
export var preview2 = "_f9-f";
export var quillEditor = "_f9-q";
export var selectedMacro = "_f9-g";
export var sidebar = "_f9-h";
export var sidebarHeader = "_f9-j";
export var sidebarList = "_f9-i";
export var sidebarListItem = "_f9-k";
export var sidebarSearch = "_f9-l";
export var snoozeDurationWrapper = "_f9-v";
export var statusPillContainer = "_f9-m";
export var tagsContainer = "_f9-n";
export var unselectedMacro = "_f9-o";
export var variable = "_f9-u";
export var wrapper = "_f9-p";